import { render, staticRenderFns } from "./A_nonrecord.vue?vue&type=template&id=5570869f&scoped=true&"
import script from "./A_nonrecord.vue?vue&type=script&lang=js&"
export * from "./A_nonrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570869f",
  null
  
)

export default component.exports